import { environment } from '../../../../../../environments/environment';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { KiwixiService } from '../../../kiwixi/kiwixi.service';
import { ExaminationService } from '../../../service/examination.service';
import { MaterialService } from '../../../service/material.service';
import { SharedAppState } from '../../../store/app.states';
import { LilateCardRecComponent } from '../lilate-card-rec.component';
import { LilateService } from '../../../service/lilate.service';
import { FormControl, Validators } from '@angular/forms';
import { UserService } from '../../../service/user.service';

@Component({
  selector: 'app-lilate-card-done-rec',
  templateUrl: './lilate-card-done-rec.component.html',
  styleUrls: ['./lilate-card-done-rec.component.scss', '../lilate-card-rec.component.scss']
})
export class LilateCardDoneRecComponent extends LilateCardRecComponent {
  @Input() bloc: string;

  certification: boolean = false;

  birthdate = new FormControl('', Validators.required);
  birthdateCheck = false;

  constructor(
    _router: Router,
    materialService: MaterialService,
    translateService: TranslateService,
    kiwixiService: KiwixiService,
    examinationService: ExaminationService,
    store: Store<SharedAppState>,
    private lilateService: LilateService,
    private userService: UserService
  ) {
    super(
      _router,
      materialService,
      translateService,
      kiwixiService,
      examinationService,
      store
    )
  }

  ngAfterViewInit(): void {
    if (this.lilate) {
      this.certification = this.lilate.level_global.value >= this.lilate.language.lilate_level ? true : false;
      if (this.lilate.student.user.birthdate) {
        this.birthdateCheck = true;
      }
    }
  }

  downloadLilateLevelAttestationPdf() {
    if (this.lilate.is_satisfaction_form_responded)
      this.lilateService.downloadLilateLevelAttestationPdf(this.lilate);
    else
      this.showCsatForm();
  }

  downloadLilateRealizationCertificatePdf() {
    if (this.lilate.is_satisfaction_form_responded)
      this.lilateService.downloadLilateRealizationCertificatePdf(this.lilate);
    else
      this.showCsatForm();
  }
  checkIdentidyValidity() {
    return this.lilateService.checkIdentidyValidity(this.lilate);
  }

  checkBirthdateValidity() {
    return this.lilate.student.user.birthdate ? true : false;
  }

  /**
  * mettre à jour un user.
  * @param user
  */
  updateUser(user) {
    if (this.birthdate.invalid) {
      this.birthdate.markAllAsTouched();
      return
    }
    const param = {
      birthdate: this.birthdate.value
    };
    this.userService.patchUser(user.url, param).then(
      () => {
        this.birthdateCheck = true;
      }
    )
  }

  onBirthdateChange(newDate: string): void {
    this.birthdate.setValue(newDate);
  }
}
